import request from '@/utils/request'

/**
 * 查询订单对账数据列表
 * @param {Object} params - 查询参数
 * @param {Number} params.pageNo - 当前页
 * @param {Number} params.pageSize - 每页数量
 * @param {Number} params.timeType - 时间类型: 1-按日 2-按月 3-按年 4-自定义
 * @param {String} params.startTime - 开始时间(格式: yyyy-MM-dd HH:mm:ss)
 * @param {String} params.endTime - 结束时间(格式: yyyy-MM-dd HH:mm:ss)
 * @param {String} params.orderNo - 订单编号
 * @param {String} params.userMobile - 用户手机号
 * @param {Number} params.storeId - 门店ID
 * @param {Number} params.merchantId - 商家ID
 * @param {Number} params.goodsId - 商品ID
 */
export function getReconciliationList(params) {
  return request({
    url: '/api/order/reconciliation/list',
    method: 'get',
    params: params
  })
}

/**
 * 获取对账数据汇总
 * @param {Object} params - 查询参数
 */
export function getReconciliationSummary(params) {
  return request({
    url: '/api/order/reconciliation/summary',
    method: 'get',
    params: params
  })
}

/**
 * 根据时间类型生成对账数据
 * @param {Object} data - 生成参数
 * @param {Number} data.timeType - 时间类型: 1-按日 2-按月 3-按年
 * @param {String} data.dateValue - 日期值
 */
export function generateByTimeType(data) {
  return request({
    url: '/api/order/reconciliation/generate',
    method: 'post',
    data: data
  })
}

/**
 * 按日生成对账数据
 * @param {Object} data - 生成参数
 * @param {String} data.date - 日期 格式: yyyy-MM-dd
 */
export function generateByDay(data) {
  return request({
    url: '/api/order/reconciliation/generate/day',
    method: 'post',
    params: data
  })
}

/**
 * 按月生成对账数据
 * @param {Object} data - 生成参数
 * @param {String} data.month - 月份 格式: yyyy-MM
 */
export function generateByMonth(data) {
  return request({
    url: '/api/order/reconciliation/generate/month',
    method: 'post',
    params: data
  })
}

/**
 * 按年生成对账数据
 * @param {Object} data - 生成参数
 * @param {Number} data.year - 年份
 */
export function generateByYear(data) {
  return request({
    url: '/api/order/reconciliation/generate/year',
    method: 'post',
    params: data
  })
}

/**
 * 生成指定时间段的订单对账数据
 * @param {Object} data - 生成参数
 * @param {String} data.startTime - 开始时间(格式: yyyy-MM-dd HH:mm:ss)
 * @param {String} data.endTime - 结束时间(格式: yyyy-MM-dd HH:mm:ss)
 */
export function generateByRange(data) {
  return request({
    url: '/api/order/reconciliation/generate/range',
    method: 'post',
    params: data
  })
}

/**
 * 重新生成指定时间段的订单对账数据（先删除后生成）
 * @param {Object} data - 生成参数
 * @param {String} data.startTime - 开始时间(格式: yyyy-MM-dd HH:mm:ss)
 * @param {String} data.endTime - 结束时间(格式: yyyy-MM-dd HH:mm:ss)
 */
export function regenerateByRange(data) {
  return request({
    url: '/api/order/reconciliation/regenerate/range',
    method: 'post',
    params: data
  })
}

/**
 * 导出对账数据
 * @param {Object} params - 查询参数
 */
export function exportReconciliation(params) {
  return request({
    url: '/api/order/reconciliation/export',
    method: 'get',
    params: params,
    responseType: 'blob'
  })
}
